export default {
  id: 44,
  title: 'Target #44 - Stripes',
  url: 'https://cssbattle.dev/play/44',
  colors: ['#1A4341', '#F3AC3C'],
  solution:
    '<a a><a b><a c><style>body,a{background:#1A4341}a{position:fixed}a[a]{top:60;left:120;width:160;height:180;background:#F3AC3C}a[b]{top:0;left:-150;width:300;height:300;border-radius:50%;box-shadow:400px 0 #1A4341}a[c]{background:#1A4341;top:80;width:385;height:20;box-shadow:0 40px #1A4341,0 80px #1A4341,0 120px #1A4341}</style>',
}
